import { ConfigState } from 'src/modules/config/types/ConfigState';
import { RootState } from 'src/types/RootState';

export function getConfigState(state: RootState): ConfigState {
  return state.config;
}
